import React, { useRef, useMemo, useEffect, useState } from 'react';
import { useTable, useGlobalFilter, useFilters, usePagination } from 'react-table';
import MOCK_DATA from '../jsx/components/table/FilteringTable/MOCK_DATA_2.json';
import { COLUMNS } from '../jsx/components/table/FilteringTable/ColumnOrders';
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from 'sweetalert';
import '../jsx/components/table/FilteringTable/filtering.css';
import { Col, Row } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import InviteCustomer31 from '../jsx/constant/ArbonAmount';
import Swal from 'sweetalert2';

export const CompanyExpenses = () => {
  const columns = useMemo(() => COLUMNS, []);
  const [data, setData] = useState([]);
  const invite31 = useRef();

 
  // NOTE: This search/filter block (CustomerID, date, endDate, selectedStatus, fetchData,
  // clearFilters, prepaysummation, messages) doesn't currently have any UI controls wired to it
  // (no inputs call setCustomerID / setDate / setEndDate / setSelectedStatus, and prepaysummation
  // / messages aren't rendered anywhere). I left it in since it looks like a half-built feature
  // rather than leftover junk — let me know if you want it removed too.
 

  
   
  
  const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);

  function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'OrdersList';
  const actionsForPage = getActionsForPage(pageName);

  const [popupModal, setpopupModal] = useState(false);

  const tableInstance = useTable({
    columns,
    data,
    initialState: { pageIndex: 0 }
  }, useFilters, useGlobalFilter, usePagination);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;
  const { globalFilter, pageIndex } = state;
  const navigate = useNavigate();

 
  

  const fetchProducts = async () => {
    await axios.get('https://suhba.education.com.ly/back/api/new_orders').then(({ data }) => { setData(data); }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
  };

  
  // Single mount effect — previously fetchgroup() was called from two separate
  // useEffects, firing the request twice on every mount.
  useEffect(() => {
     fetchProducts();
   }, []);

  function orderlist(id) {
    data.map((item) => {
      if (id == item.OrderID) {
        setReastAmount(item.TotalAmount - item.amounts);
        setIID(id);
        setERrr('');
        setpopupModal(true);
      }
    });
  }

  const [reastAmount, setReastAmount] = useState('');
  const [IID, setIID] = useState('');
  const [Amount, setAmount] = useState('');
  const [Err, setERrr] = useState('');
  const [report, setreport] = useState({});

  const handleEdit = async () => {
    setERrr('');

    if (Amount > reastAmount) {
      setERrr('القيمة المدخلة اكبر من القيمة المتبقية');
      return;
    }

    try {
      const response = await axios.put(`https://suhba.education.com.ly/back/api/dipositorders/${IID}`, {
        Amount: Amount,
        OrderID: IID,
        UserID: userid,
      });

      Swal.fire({
        icon: 'success',
        title: 'تم التحديث بنجاح',
        text: 'تم تحديث حالة الدفع بنجاح.',
        confirmButtonText: 'حسناً'
      }).then(() => {
        fetchProducts();
        setpopupModal(false);
        const depositData = response.data.Deposit;
        if (depositData) {
          data.map((item) => {
            if (IID == item.OrderID) {
              const newObj = {
                amount: depositData.amount,
                CustomerName: item.CustomerName,
                deposit_date: depositData.deposit_date,
                reference_number: depositData.reference_number,
                deposits: depositData.deposits,
                reastAmount: (item.TotalAmount - item.Prepay),
                UserName: item.UserName
              };
              setreport(newObj);
            }
          });
          invite31.current.showInviteModal();
        } else {
          swal(" هده الطلبية ملغية");
        }
      });
    } catch (error) {
      let errorMessage = 'حدث خطأ غير متوقع.';
      if (error.response) {
        console.error('Server error:', error.response.data);
        errorMessage = error.response.data.message || 'حدث خطأ من السيرفر.';
      } else if (error.request) {
        console.error('No server response:', error.request);
        errorMessage = 'لا يوجد استجابة من السيرفر. تحقق من الاتصال بالإنترنت.';
      } else {
        console.error('Unexpected error:', error.message);
        errorMessage = error.message;
      }

      Swal.fire({
        icon: 'error',
        title: 'خطأ!',
        text: errorMessage,
        confirmButtonText: 'موافق'
      });
    }
  };

  const userdata1 = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata1);
  const userid = userData.id;

  // Cancels/deletes an order (used by the "إلغاء الطلب" button below)
//   const handleActioncancelorder = async (id, field, value) => {
//     swal({
//       title: "هل متأكد من الالغاء",
//       text: " في حال الغاء الطلبية   لايمكنك استعادتها ",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     })
//       .then(willDelete => {
//         if (willDelete) {
//           const currentPageIndex = state.pageIndex;

//           let temp = data.map((data) => {
//             if (id === data.OrderID) {
//               return { ...data, [field]: value };
//             }
//             return data;
//           });
//           setData(temp);
//  axios.put(
//   `https://suhba.education.com.ly/back/api/cancel-order/${id}`,
//   {
//     UserID: userid
//   }
// )
          
//             .catch(function (error) {
//               if (error.response) {
//                 console.log(error.response.data);
//                 console.log(error.response.status);
//                 console.log(error.response.headers);
//               } else if (error.request) {
//                 console.log(error.request);
//               } else {
//                 console.log('Error', error.message);
//               }
//               console.log(error.config);
//             });
//           gotoPage(currentPageIndex);
//         } else {
//           swal("تم التراجع عن عملية الالغاء");
//         }
//       });
//   };
const handleActioncancelorder = async (id, field, value) => {
  swal({
    title: "هل متأكد من الإلغاء؟",
    text: "في حال إلغاء الطلبية لا يمكنك استعادتها.",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  }).then(async (willDelete) => {
    if (willDelete) {
      const currentPageIndex = state.pageIndex;

      try {
        await axios.put(
          `https://suhba.education.com.ly/back/api/cancel-order/${id}`,
          {
            UserID: userid,
          }
        );

        // Refresh data from the server
        await fetchProducts();

        // Return to the same page
        gotoPage(currentPageIndex);

        swal("تم إلغاء الطلبية بنجاح", {
          icon: "success",
        });
      } catch (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }

        swal("حدث خطأ أثناء إلغاء الطلبية", {
          icon: "error",
        });
      }
    } else {
      swal("تم التراجع عن عملية الإلغاء");
    }
  });
};
 
  const visibleColumns = [
    'CustomerName',
    'OrderDate',
    'PhoneNumber',
  ];
  const isColumnVisible = (column) => {
    return visibleColumns.includes(column.id);
  };

  return (
    <>
      <div className='container-fluid'>
        <Row>
          <Col lg="12">
            <div className="card">
              <div className="card-header">
                <h4 className="heading mb-0">الطلبيات المبدئية</h4>
                <div className='d-flex' style={{ justifyContent: 'left' }}></div>
              </div>

 
              <div className="table-responsive">
                <table {...getTableProps()} className="table dataTable display scrol table-hover">
                  <thead>
                    {headerGroups.map(headerGroup => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers
                          .filter(isColumnVisible)
                          .map(column => (
                            <th {...column.getHeaderProps()}>
                              {column.render('Header')}
                              {column.canFilter ? column.render('Filter') : null}
                            </th>
                          ))}
                        <th>القيمة</th>
                        <th>الإجراءات</th>
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row, index) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()} key={index}>
                          {row.cells
                            .filter(cell => isColumnVisible(cell.column))
                            .map(cell => (
                              <td {...cell.getCellProps()}>
                                {cell.render('Cell')}
                              </td>
                            ))}

                          <td>{row.original.TotalAmount - row.original.amounts}</td>

                          <td>
                           <div style={{ display: 'flex', gap: '5px' }}>
  <button
    type="button"
    className="btn btn-sm btn-outline-success"
    onClick={() => orderlist(row.original.OrderID)}
  >
    <i className="fa-brands fa-amazon-pay"></i> دفع العربون
  </button>

  <button
    type="button"
    className="btn btn-sm btn-outline-danger"
    onClick={() => handleActioncancelorder(row.original.OrderID, 'Status', 'ملغي')}
  >
    <i className="fa fa-trash"></i> إلغاء الطلب
  </button>
</div>
                             
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                <div className="d-flex justify-content-between mx-2">
                  <span>
                    الصفحه{' '}
                    <strong>
                      {pageIndex + 1} من {pageOptions.length}
                    </strong>{''}
                  </span>
                  <span className="table-index ">
                    ادهب الى :{' '}
                    <input type="number"
                      className="ml-2"
                      defaultValue={pageIndex + 1}
                      onChange={e => {
                        const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
                        gotoPage(pageNumber);
                      }}
                    />
                  </span>
                </div>
                <div className="text-center mb-3">
                  <div className="filter-pagination  mt-3">
                    <button className="previous-button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                      <i className='fa-solid fa-angle-right' />
                    </button>
                    <button className="previous-button" onClick={() => previousPage()} disabled={!canPreviousPage}>
                      السابق
                    </button>
                    <button className="next-button" onClick={() => nextPage()} disabled={!canNextPage}>
                      التالي
                    </button>
                    <button className="next-button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                      <i className='fa-solid fa-angle-left' />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <Modal className="fade bd-example-modal-sm" size="sm" id="exampleModal1" show={popupModal} centered>
        <div className="modal-content">
          <div className="modal-body">
            <div className="col-sm-12">
              <div>
                <label className="form-label">القيمة الكلية : {reastAmount}</label>
              </div>
              <div>
                <label className="form-label">ادخل قيمة العربون<span className="text-danger">*</span></label>
              </div>
              <input type="text"
                className="form-control"
                defaultValue=''
                required
                id="inputcity"
                name="city"
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div style={{ color: "red" }}>{Err}</div>
            <div className="card-footer">
              <button type="button" className="btn btn-primary light mx-1" onClick={handleEdit}>اضف</button>
              <button type="button" className="btn btn-danger light" onClick={() => setpopupModal(false)}>اغلاق</button>
            </div>
          </div>
        </div>
      </Modal>

      <InviteCustomer31 ref={invite31} data={report} />
    </>
  );
};

export default CompanyExpenses;
